__turbopack_context__.v({
  "dropdown": "Dropdown-module-scss-module__B7Ke_G__dropdown",
  "hide": "Dropdown-module-scss-module__B7Ke_G__hide",
  "label": "Dropdown-module-scss-module__B7Ke_G__label",
  "link": "Dropdown-module-scss-module__B7Ke_G__link",
  "listButton": "Dropdown-module-scss-module__B7Ke_G__listButton",
  "menu": "Dropdown-module-scss-module__B7Ke_G__menu",
  "option": "Dropdown-module-scss-module__B7Ke_G__option",
  "option--active": "Dropdown-module-scss-module__B7Ke_G__option--active",
  "options": "Dropdown-module-scss-module__B7Ke_G__options",
  "trigger": "Dropdown-module-scss-module__B7Ke_G__trigger",
  "triggerIcon": "Dropdown-module-scss-module__B7Ke_G__triggerIcon",
});
